module.exports = "/images/ticket.svg?1d920e2abd8de1247ef48bf5cece7c5b";